import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ISection } from 'src/app/pages/project-management/service-roadmaps/roadmap-interface';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { GraphService } from 'src/app/services/graph/graph.service';
import { LanguageSupportService } from 'src/app/services/language-support.service';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { Step, SubSection } from '../../pages/project-management/risk-assessment-sections/roadmap-interface';
import { ToastService } from 'src/app/services/toast.service';
import { AppConstants } from 'src/app/utilities/constant';

@Component({
  selector: 'app-service-riskassessment-accordion',
  templateUrl: './service-riskassessment-accordion.component.html',
  styleUrls: ['./service-riskassessment-accordion.component.scss'],
})
export class ServiceRiskassessmentAccordionComponent implements OnInit {
  @Input() sectionName: string;
  @Input() roadmapStatus: string;
  @Input() subSectionName: string;
  @Input() subSectionSteps: any = [];
  @Input() isCustom: string;
  @Input() roadMapName: string;
  @Input() subSectionIndex: number;
  @Input() roadmapsCompleteData: ISection[] = [];
  @Input() roadMapId: string;
  @Output() provideComplianceType: EventEmitter<any> = new EventEmitter();
  isListItemOpened = false;
  files = [];
  imageSrc: any;
  queryParams: any={};
  // stepName: any;
  selectedLanguage: string = this.serviceMulti.getDefaultLanguage();

  constructor(private serviceMulti: LanguageSupportService,
    private toastService: ToastService,
    private route: ActivatedRoute, public backendService: BackendCallService, private router: Router, private domSanitizer: DomSanitizer, private sharedValue: ShareValuesService, private graphService: GraphService) {
    this.route.queryParams.subscribe(async (params) => {
      this.queryParams=params;
    });
  }

  checkComplianceType(complianceType) {
    this.provideComplianceType.emit(complianceType);
  }

  ngOnInit() {
  }

  toggleAccordion(step, index, list): void {
    list[index - 1] ? list[index - 1].isListItemOpened = false : '';
    list[index + 1] ? list[index + 1].isListItemOpened = false : '';
    step.isListItemOpened = !step.isListItemOpened;
  }

  toggleHazard(step): void {
    step.isHazardOpened = !step.isHazardOpened;
  }

  deleteStep(deleteStep, i) {
    if (deleteStep.id) {
      this.roadmapsCompleteData.forEach((eachSection: ISection) => {
        const subSections = eachSection.subSections;
        subSections.forEach((eachSubSection: SubSection) => {
          eachSubSection.steps.forEach((step: Step) => {
            if (deleteStep.id == step.id) {
              const payload = {
                id: this.roadMapId,
                serviceMachineId: this.queryParams.serviceMachineId,
                projectId: this.queryParams.project_id,
                section: [
                  {
                    sectionId: eachSection.sectionId,
                    isDelete: false,
                    subSection: [
                      {
                        subSection_Id: eachSubSection.subSection_Id,
                        isDelete: false,
                        steps: [
                          {
                            id: step.id,
                            isDelete: true
                          }
                        ]
                      }
                    ]
                  }
                ]
              };
              this.backendService.deleteRoadmapSectionsData(payload).subscribe(
                (data: any) => {
                  this.subSectionSteps.splice(i, 1);
                  this.provideComplianceType.emit('step');
                  this.toastService.presentToast(data, 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
                },
                (err) => {
                }
              );
            }
          });
          // }
        });
      });
    } else {
      this.subSectionSteps.splice(i, 1);
      // if(subSectionSteps==[]){
      this.provideComplianceType.emit('step');
      // }
    }

  }

  markAsComplete(step) {
    step.isListItemOpened = !step.isListItemOpened;
  }

  deleteImage(eachImg, eachImgArry: [], i) {
    if (eachImg.id) {
      const payload = {
        id: eachImg.id,
        fileName: eachImg.fileName,
        contentType: '',
        url: eachImg.url,
        driveId: eachImg.driveId,
        itemId: eachImg.itemId,
        isType: 'complaint',
      };
      this.backendService.deleteMediaFile(payload).subscribe((res: any) => {
        eachImgArry.forEach((element: any) => {
          if (element.fileName == eachImg.fileName) {eachImgArry.splice(i, 1);}
        });
        this.graphService.deleteItem(eachImg.driveId, eachImg.itemId).subscribe(res => {
        });
      },err=>{
        this.toastService.presentToast('no_results_found', 4000, AppConstants.ERROR_SNACKBAR, 'top');
      });
    } else {
      eachImgArry.splice(i, 1);
    }
  }

  uploadFile(fileChangeEvent, step, index: number, complaintImage: HTMLInputElement) {
    const self = this;
    if (fileChangeEvent.target.files && fileChangeEvent.target.files[0]) {
      const file = fileChangeEvent.target.files[0];
      const reader = new FileReader();
      reader.onload = e => {
        self.imageSrc = reader.result;
        // self.files.push(self.imageSrc);
        step.previewImages = step.previewImages || [];
        step.previewImages.push({ img: self.imageSrc, name: fileChangeEvent.target.files[0]?.name });
      };
      reader.readAsDataURL(file);
    }
    const file = fileChangeEvent.target.files[0];
    const fileName = fileChangeEvent.target.files[0].name;
    const fileType = fileName.match(/\.[0-9a-z]+$/i);

    const fileSize = fileChangeEvent.target.files[0].size;
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = async () => {
      const folderPath = 'General/Machines/' + this.sharedValue.selectedMachineName;
      const UploadImageFolderPath = 'Pictures';
      await this.checkFolderExists(folderPath, UploadImageFolderPath);
      await this.UploadFileToSharePoint(folderPath + '/' + UploadImageFolderPath, fileName, file, fileSize, fileType, step);
    };
    reader.onerror = (error) => {
    };
    complaintImage.value = '';
  }


  async checkFolderExists(folderPath, name) {
    this.graphService.getFolderDetails(folderPath).subscribe((res: any) => {
      if (res) {
        if (res.value.filter(function(e) { return e.name === name; }).length == 0) {
          const folderPathDetails = 'General/Machines/' + this.sharedValue.selectedMachineName;
          this.createFolder(folderPathDetails, name);
        }
      }
    });
  }

  async UploadFileToSharePoint(folderPath, fileName, file, fileSize, fileType, step) {
    if (fileSize < 4194304) {
      this.graphService.UploadFile(fileName, file, folderPath).subscribe((res: any) => {
        if (res) {
          const imageData = {
            fileName: res.name,
            contentType: res.file.mimeType,
            url: res.webUrl,
            driveId: res.parentReference.driveId,
            itemId: res.id,
            image_Size:fileSize
          };
          if (step.complaintMedia == null) {step.complaintMedia = [];}
          step.complaintMedia.push(imageData);
        }
      });
    } else if(fileSize < 94371840){
     this.graphService.createUploadSession(fileName,fileSize,folderPath).subscribe((res: any) => {
        if(res.uploadUrl){
          this.sharedValue.uploadChunks(file, res.uploadUrl).then((res: any)=>{
            if (res[1]) {
              const imageData = {
                fileName: res[1].name,
                contentType: res[1].file.mimeType,
                url: res[1].webUrl,
                driveId: res[1].parentReference.driveId,
                itemId: res[1].id,
                image_Size:fileSize
              };
              if (step.complaintMedia == null) {step.complaintMedia = [];}
              step.complaintMedia.push(imageData);
            }
          });
        }else if (res.error) {          
          this.toastService.presentToast(res.error.message, 4000, AppConstants.ERROR_SNACKBAR, 'top');
        }
      });
    }else{      
      this.toastService.presentToast('Image size exceeds 10MB', 4000, AppConstants.ERROR_SNACKBAR, 'top');
    }
  }

  async createFolder(folderPath, name) {
    const folderCreatePayload = {
      name,
      folder: {},
      '@microsoft.graph.conflictBehavior': 'rename'
    };
    this.graphService.createFolder(folderCreatePayload, folderPath).subscribe((res) => {
    });
  }




}
